'use client';

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

export const PaymentPageRedirect = ({ locationData }) => {
	const router = useRouter();

	useEffect(() => {
		const url = new URL(process.env.NEXT_PUBLIC_PAYMENT_URL);
		url.searchParams.set('variation', 'gfesale');
		const searchParams = new URLSearchParams(window.location.search);
		searchParams.forEach((value, key) => {
			url.searchParams.set(key, value);
		});
		url.searchParams.set('country', locationData.country);
		url.searchParams.set('city', locationData.city);
		url.searchParams.set('state', locationData.state);

		router.push(url.toString());
	}, []);

	return null;
};
